import React from 'react';

interface BodyCallOutTextProps {
  bodyCallOutText: string;
}

export const BodyCallOutText: React.FC<BodyCallOutTextProps> = (props: BodyCallOutTextProps) => {
  return (
    <div className="col-span-full lg:col-span-8 lg:col-start-2 mt-8 mb-8 lg:mt-10 lg:mb-10">
      <section className="bg-ivory p-10" data-module="callout">
        <p className="type-zeta text-green-dark text-center">{props.bodyCallOutText}</p>
      </section>
    </div>
  );
};
